import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"

export default class extends Controller {
  static targets = ["itemsContainer", "itemTemplate", "validityType", "monthsField", "exactDateField", "dateInput"]

  connect() {
    this.itemIndex = this.itemsContainerTarget.querySelectorAll('.coupon-batch-item').length
    this.toggleValidityFields()
    this.initializeDatePicker()
  }

  initializeDatePicker() {
    if (this.hasDateInputTarget) {
      flatpickr(this.dateInputTarget, {
        enableTime: false,
        locale: "fr",
        dateFormat: "d/m/Y",
        allowInput: true,
        altInput: false
      })
    }
  }

  addItem(event) {
    event.preventDefault()

    const template = this.itemTemplateTarget.innerHTML.replace(/NEW_RECORD/g, this.itemIndex)
    this.itemsContainerTarget.insertAdjacentHTML('beforeend', template)

    this.itemIndex++
  }

  removeItem(event) {
    event.preventDefault()

    const item = event.target.closest('.coupon-batch-item')
    const destroyInput = item.querySelector('input[name*="_destroy"]')

    if (destroyInput) {
      destroyInput.value = '1'
      item.style.display = 'none'
    } else {
      item.remove()
    }
  }

  updatePrice(event) {
    const select = event.target
    const selectedOption = select.options[select.selectedIndex]
    const item = select.closest('.coupon-batch-item')
    const priceInput = item.querySelector('.price-input')
    const priceEurosInput = item.querySelector('.price-euros-input')

    if (selectedOption && selectedOption.dataset.price) {
      const priceCents = parseInt(selectedOption.dataset.price)
      priceInput.value = priceCents
      priceEurosInput.value = (priceCents / 100).toFixed(2)
    }
  }

  updateCents(event) {
    const eurosInput = event.target
    const item = eurosInput.closest('.coupon-batch-item')
    const priceInput = item.querySelector('.price-input')

    const euros = parseFloat(eurosInput.value) || 0
    priceInput.value = Math.round(euros * 100)
  }

  toggleValidityFields() {
    if (!this.hasValidityTypeTarget) return

    const validityType = this.validityTypeTarget.value

    if (validityType === 'months') {
      this.monthsFieldTarget.style.display = 'block'
      this.exactDateFieldTarget.style.display = 'none'
    } else {
      this.monthsFieldTarget.style.display = 'none'
      this.exactDateFieldTarget.style.display = 'block'
    }
  }
}
